<template>
  <div class="courses">
    <v-card v-if="cycle.Description != ''">
      <v-card-title>
        <div>
          {{ cycle.Description }}
        </div>
      </v-card-title>
    </v-card>
    <div v-if="isMobile">
      <v-card
        v-for="course in courses"
        :key="course.ClassID"
        @click="handleSwitch"
      >
        <v-card-title class="info-detail">
          <v-switch color="primary" v-model="course.Selected"></v-switch>
          <div class="text-center">
            {{ course.TitleName }}
            {{ course.TextBook != "" ? " - " + course.TextBook : "" }}
          </div>
        </v-card-title>
        <div
          class="contain"
          :style="[
            course.RegisterID != null && course.Selected
              ? { 'background-color': 'rgba(0, 255, 0, 0.5)' }
              : course.Selected ||
                (course.RegisterID != null && !course.Selected)
              ? { 'background-color': '#00d10040' }
              : '',
          ]"
        >
          <div
            v-if="course.Description != ''"
            class="desc"
            :class="[course.State ? 'green-row' : 'red-row']"
          >
            <font-awesome-icon :icon="course.State ? 'check' : 'exclamation'" />
            {{ course.Description }}
            <font-awesome-icon :icon="course.State ? 'check' : 'exclamation'" />
          </div>
          <app-row icon="book" title="کد درس: " :value="course.TitleCode" />
          <app-row
            icon="user-circle"
            title="نام استاد: "
            :value="course.TeacherName"
          />
          <app-row icon="hashtag" title="تعداد واحد: " :value="course.Vahed" />
          <app-row icon="briefcase" title="پایه: " :value="course.PayehName" />
          <app-row icon="clock" title="زمان کلاس: " :value="course.ClassTime" />
          <app-row
            icon="building"
            title="محل کلاس: "
            :value="course.CycleLocation"
          />
          <app-row icon="users" title="ظرفیت کلاس: " :value="course.Capacity" />
          <app-row  title="توضیحات: " :value="course.Description" />

        </div>
      </v-card>
    </div>
    <div v-else>
      <v-data-table
        :items="courses"
        :headers="coursesHeaders"
        class="elevation-1"
        :disable-pagination="true"
        :hide-default-footer="true"
        :item-class="itemRowBackground"
        item-key="ClassID"
        show-expand
      >
        <template v-slot:[`item.State`]="{ item }">
          <v-simple-checkbox
            v-model="item.Selected"
            @input="handleSwitch"
            :ripple="false"
          ></v-simple-checkbox>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            {{ item.Description }}
          </td>
        </template>
      </v-data-table>
    </div>
    <div class="confirm" v-if="showButton">
      <v-btn
        class="register"
        :class="!isMobile ? 'btnMargin' : ''"
        color="red white--text"
        rounded
        @click="registerClasses"
      >
        ثبت
      </v-btn>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
import { registerClasses } from "@/api/cycle";
export default {
  data() {
    return {
      showButton: false,
      cycleData: this.cycle,
      coursesHeaders: [
        {
          text: "",
          value: "State",
          width: "0%",
          sortable: false,
        },
        {
          text: "عنوان",
          value: "TitleName",
          width: "20%",
        },
        {
          text: "متن درس",
          value: "TextBook",
          width: "20%",
        },
        {
          text: "کد درس",
          value: "TitleCode",
          width: "5%",
        },
        {
          text: "نام استاد",
          value: "TeacherName",
          width: "10%",
        },
        {
          text: "تعداد واحد",
          value: "Vahed",
          width: "5%",
        },
        {
          text: "پایه",
          value: "PayehName",
          width: "10%",
        },
        {
          text: "زمان کلاس",
          value: "CycleTime",
          width: "5%",
        },
        {
          text: "محل کلاس",
          value: "CycleLocation",
          width: "10%",
        },
        {
          text: "ظرفیت کلاس",
          value: "Capacity",
          width: "5%",
        },
        {
          text: "توضیحات",
          value: "data-table-expand",
          width: "5%",
        },
      ],
    };
  },
  props: ["cycle"],
  components: {
    appRow: DetailRow,
  },
  computed: {
    courses() {
      return this.cycleData.Classes;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },

  methods: {
    itemRowBackground: function(course) {
      return course.RegisterID != null && course.Selected
        ? "green-row"
        : course.Selected || (course.RegisterID != null && !course.Selected)
        ? "changed-row"
        : "";
    },
    /**
     * user select class
     */
    handleSwitch() {
      this.$store.commit("SET_SNACKBAR_SHOW", false);
      this.showButton = true;
    },
    /**
     * register classes
     */
    registerClasses() {
      this.showButton = false;
      var classIds = [];
      for (var i = 0; i < this.courses.length; i++) {
        this.courses[i].Description = "";
        if (this.courses[i].Selected) {
          classIds.push(this.courses[i].ClassID);
        }
      }
      /**
       * call api
       */
      /**
       * update registered classes
       */
      registerClasses(classIds, this.cycle.cycleID)
        .then((response) => {
          const data = response.data;
          var error = false;
          for (var regId = 0; regId < data.length; regId++) {
            for (var classid = 0; classid < this.courses.length; classid++) {
              if (data[regId].ClassID == this.courses[classid].ClassID) {
                this.cycleData.Classes[classid].Description =
                  data[regId].Description;
                this.cycleData.Classes[classid].State = data[regId].State;
                this.cycleData.Classes[classid].RegisterID =
                  data[regId].RegisterID;

                break;
              }
            }
            error = error || !data[regId].State;
          }
          if (error) {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "برخی از دروس شما به درستی انتخاب نشده اند. لطفا اشکالات را مرتفع فرمایید."
            );
          }
          /**
           * update non-register classes
           */
          for (var classid = 0; classid < this.courses.length; classid++) {
            if (this.courses[classid].Description == "") {
              this.cycleData.Classes[classid].State = false;
              this.cycleData.Classes[classid].RegisterID = null;
            }
          }
        })

        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.courses {
  top: 120px;
}
.info-title {
  background-color: white;
}

.v-input--switch {
  margin-right: 50px;
}

.desc {
  text-align: center;
  margin: 15px;
  height: 54px;
  color: white;
  padding: 15px;
  border-radius: 27px;
}
.contain {
  padding-top: 1px;
  border-radius: 0px 0 15px 15px;
}
</style>
